import React from 'react'
import { useSelector } from 'react-redux'
import { SetPriceTask, UploadTask, DownloadTask } from './tasks'
import { selectCurrentStatus } from 'components/QuestionnaireRequestAutomated/processor/slices/globalSlice'

export default function ManualTasks() {
  const currentStatus = useSelector(selectCurrentStatus)
  const isStatusIntake = currentStatus === 'intake'
  const hasCanceled = currentStatus === 'canceled'
  const hasArchived = currentStatus === 'archived'

  return (
    <div className="dome-d-flex dome-flex-column">
      <SetPriceTask />
      <DownloadTask disabled={hasCanceled || hasArchived} />
      <UploadTask disabled={isStatusIntake || hasCanceled || hasArchived} />
    </div>
  )
}
